<template>
<transition @enter="enter" @leave="leave" appear>
  <aside class="info" v-if="conference !== undefined">
    <ul class="info__container u-hidden--until-ipadP">
      <li class="info__item">{{ conference.country }}</li>
      <li class="info__item">Awwwards Conference</li>
      <li class="info__item">{{ conference.date }}</li>
    </ul>
    <transition name="fade">
      <div
        v-show="allways ? allways : $store.state.isMenuOpen"
        :key="allways ? allways : $store.state.isMenuOpen"
        class="info__container u-hidden--from-ipadP"
        ref="marquee"
      >
        <ul class="info__subcontainer">
          <li class="info__item">{{ conference.country }}</li>
          <li class="info__item">Awwwards Conference</li>
          <li class="info__item">{{ conference.date }}</li>
        </ul>
        <ul class="info__subcontainer">
          <li class="info__item">{{ conference.country }}</li>
          <li class="info__item">Awwwards Conference</li>
          <li class="info__item">{{ conference.date }}</li>
        </ul>
      </div>
    </transition>
  </aside>
</transition>
</template>

<script>
import { initials, animations } from '../scripts/fx';

export default {
  name: 'Info',
  props: {
    allways: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      conferences: {
        amsterdam: { country: 'Amsterdam', date: '19 - 21 . February ’20' },
        toronto: { country: 'Toronto', date: '14 - 16 . July ’20' },
        'san-francisco': { country: 'San Francisco', date: '18 - 20 . November ’20' },
      },
    };
  },
  computed: {
    conference() {
      return this.conferences[this.$route.params.city];
    },
  },
  methods: {
    enter(el, done) {
      const container = el.querySelector('.u-hidden--until-ipadP');
      const texts = [...container.querySelectorAll('.info__item')];
      texts.forEach(text => initials.get('fade')(text, -50));

      animations.get('fade')(texts[0], 500);
      animations.get('fade')(texts[1], 700);
      animations.get('fade')(texts[2], 900).finished.then(done);
    },
    leave(el, done) {
      const container = el.querySelector('.u-hidden--until-ipadP');
      const texts = [...container.querySelectorAll('.info__item')];

      animations.get('fadeReverse')(texts[0], 0, -40);
      animations.get('fadeReverse')(texts[1], 100, -40);
      animations.get('fadeReverse')(texts[2], 200, -40).finished.then(done);
    },
    openMenu() {
      this.$store.commit('SET_MENU_STATE', !this.$store.state.isMenuOpen);
    },
  },
};
</script>

<style lang="scss" scoped>
.info {
  position: fixed;
  font-size: 16px;

  @include mq($from: dm) {
    font-size: 20px;
  }

  @include mq($from: dxl) {
    font-size: 24px;
  }

  @include mq($until: ipadP) {
    top: $unit-vh * 6;
    left: 0;
    width: 100%;

    overflow: hidden;
    z-index: 50;

    .info__container {
      margin: 0;
      margin-left: 20px;
      transform-style: unset;
      width: 100000px;
      box-sizing: border-box;
      line-height: 1.15;

      transition: transform 0.8s $inOutCirc,
        opacity 0.8s $inOutCirc;

      &.info--hidden {
        transform: translateY(-80px);
        opacity: 0;
        pointer-events: none;
      }

      .info__subcontainer {
        float: left;
        display: block;

        will-change: transform;
        backface-visibility: hidden;
        animation: marquee-text-animation 15s infinite linear;

        li {
          display: inline-block;
          padding: 0 50px;
        }
      }
    }
  }

  @include mq (ipadP) {
    top: 0;
    left: 0;
    width: $unit-vh * 26;
    height: $unit-vw * 8;

    transform: rotate(-90deg) translateX(calc(-100% - (#{$unit-vh} * 8)));
    transform-origin: left top;

    pointer-events: none;

    &__container {
      margin: 0 auto;
      height: 100%;

      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__item {
      display: inline-block;
    }
  }

  .fade-enter-active {
    transition: opacity .5s $outCirc 0.5s,
      transform .5s $outCirc 0.5s;
  }

  .fade-leave-active {
    transition: opacity .5s $outCirc,
      transform .5s $outCirc;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
    transform: translateY(20px);
  }

  .fade-leave-to {
    transform: translateY(-20px);
  }
}
</style>
